(ns manatee.components.notifications.handlers
  (:require [ajax.core :refer [json-response-format]]
            [kee-frame.core :as kf]
            [manatee.components.notifications.db :as db]
            [manatee.uuid]
            [re-frame.core :as rf]))

(kf/reg-chain
 ::load-announcements
 (fn load-announcements
   [_ _]
   {:http-xhrio {:method :get
                 :uri    (kf/path-for [:api/active-messages])
                 :on-failure [::load-failure "announcements" {} nil]
                 :response-format (json-response-format {:keywords? true})}})
 (fn load-announcements-success
   [{:keys [db]} [announcements]]
   {:db (db/set-announcements db (zipmap (map :id announcements) (map :message-text announcements)))}))

(rf/reg-event-db
 ::show-announcements
 (fn show-announcements [db [_ yes?]]
   (db/show-announcements db yes?)))

(rf/reg-event-fx
 ::add-alert
 [(rf/inject-cofx :uuid)]
 (fn [{:keys [db uuid]} [_ banner-id alert & {:keys [alert-id timeout auto-dismiss?]
                                              :or {timeout 5000
                                                   auto-dismiss? true}}]]
   (cond-> {:db (db/add-alert db banner-id (or alert-id uuid) alert)}
     auto-dismiss? (assoc :dispatch-later [{:ms timeout :dispatch [::clear-alert banner-id (or alert-id uuid)]}]))))

(rf/reg-event-fx
 ::clear-alert
 (fn [{:keys [db]} [_ banner-id alert-id]]
   {:db (db/clear-alert db banner-id alert-id)}))
